/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLegalDocument = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m19 16.944-6 1.8v-2.088l6-1.8zm0-4-6 1.8v-2.088l6-1.8zm0-4-6 1.8V8.656l6-1.8z" />
        <path d="M20.713 2.386A1 1 0 0 1 22 3.344v15.912a1 1 0 0 1-.713.958l-9 2.7-.143.032a1 1 0 0 1-.289 0l-.142-.032-9-2.7A1 1 0 0 1 2 19.256V3.344a1 1 0 0 1 1.287-.958l8.426 2.528a1 1 0 0 0 .432.032l.142-.032zm-7.85 4.443a3.002 3.002 0 0 1-1.725 0L4 4.688v13.824l8 2.4 8-2.4V4.688z" />
      </g>
    </g>
  </Icon>
);
export { SvgLegalDocument as LegalDocument };
